import cx from "classnames";
import { EMOTIONS_PATHS } from "../constants";
import styles from "../FullscreenPresentationLayout.module.scss";
import { getEmoteUrl } from "../utils";

type ReactionBarProps = {
    chooseReaction: (src: string) => void;
};
export const ReactionBar = ({ chooseReaction }: ReactionBarProps) => {
    return (
        <div className={cx(styles.navigation, styles.reactionBar)}>
            {EMOTIONS_PATHS.map((path) => {
                return (
                    <button
                        key={path}
                        className={styles.navigationButton}
                        type="button"
                        onClick={() => chooseReaction(getEmoteUrl(path))}
                    >
                        <img alt="emote" src={getEmoteUrl(path)} />
                    </button>
                );
            })}
        </div>
    );
};
